/* eslint-disable */

// 数字转为为万
export function transformNum(val) {
    if (val > 10000 && val < 100000000) {
        val = val / 10000
        val = val.toFixed(1) + 'w'
    }

    if (val > 100000000) {
        val = val / 100000000
        val = val.toFixed(1) + '亿'
    }

    return val
}
// 时间戳转化
export function showTime(time) {
    let date = null
    if ((time + '').length === 10) {
        date = new Date(time * 1000)
    } else {
        date = new Date(time)
    }
    const Y = date.getFullYear()
    const M = date.getMonth() + 1
    const D = date.getDate()
    const H = date.getHours()
    const MM = date.getMinutes()
    const S = date.getSeconds()
    return `${Y}-${(M > 9 ? M : ('0' + M))}-${(D > 9 ? D : ('0' + D))} ${(H > 9 ? H : ('0' + H))}:${(MM > 9 ? MM : ('0' + MM))}:${(S > 9 ? S : ('0' + S))}`
}

// 平均数取整

export function toInt(val) {
    return parseInt(val)
    // return val
}


// 平均数取整

export function length(val) {
    return val.length
    // return val
}

//显示日期在页面上 yyy-MM-dd
export function getdate() {
    var date = new Date();
    //年
    var year = date.getFullYear();
    //月
    var month = date.getMonth() + 1;
    //日
    var day = date.getDate();
    //时
    var hh = date.getHours();
    //分
    var mm = date.getMinutes();
    //秒
    var ss = date.getSeconds();
    var rq = year + "年" + month + "月" + day + "日" + hh + ":" + mm + ":" + ss;
    document.getElementById("rq").innerHTML = rq;
}
